import React from 'react'

import { Link } from 'gatsby-plugin-intl'

import IconEmail from '~/assets/draft.svg'
import IconAddress from '~/assets/home_filled.svg'
import IconPhone from '~/assets/phone.svg'
import IconFacebook from '~/assets/social-facebook.svg'
import IconInstagram from '~/assets/social-instagram.svg'
import IconLinkedin from '~/assets/social-linkedin.svg'
import IconTwitter from '~/assets/social-twitter.svg'
import IconYoutube from '~/assets/social-youtube.svg'
import { Links } from '~/constants/links'
import translate from '~/locale'

import {
  CopyrightContainer,
  FooterColumn,
  FooterColumnContainer,
  FooterWrapper,
} from './styles'

const Footer: React.FC = () => {
  return (
    <FooterWrapper id="footer">
      <FooterColumnContainer>
        <FooterColumn flex="1">
          <span>{translate('aboutus').toUpperCase()}</span>
          <p>{translate('weresortofanexception')}</p>
        </FooterColumn>
        <FooterColumn>
          <span>{translate('morelinks')}</span>

          <ul className="normal">
            <li>
              <Link to={Links.ABOUT}>{translate('aboutus')}</Link>
            </li>
            <li>
              <a
                href="https://www.baseline.io/blog"
                rel="noreferrer"
                target="_blank"
              >
                {translate('our_blog')}
              </a>
            </li>
            <li>
              <Link to={Links.CARRERS}>{translate('career')}</Link>
            </li>
            <li>
              <Link to={Links.LEGAL}>{translate('support_termsofuse')}</Link>
            </li>
            <li>
              <a
                href="https://resident.ideas.aha.io/"
                rel="noreferrer"
                target="_blank"
              >
                {translate('submit_an_idea')}
              </a>
            </li>
          </ul>
        </FooterColumn>
        <FooterColumn>
          <span>{translate('contact_us_caps')}</span>
          <ul>
            <li>
              <a href="tel:450-238-1400">
                <IconPhone />
                450-238-1400
              </a>
            </li>
            <li>
              <a href="mailto:info@baseline.io">
                <IconEmail />
                info@baseline.io
              </a>
            </li>
            <li>
              <IconAddress />
              324 Chemin du Tour, Laval Quebec
            </li>
            <li className="social-grid">
              <a
                href="https://www.linkedin.com/company/residentapp/"
                target="_blank"
                rel="noreferrer"
              >
                <IconLinkedin />
              </a>
              <a
                href="https://www.facebook.com/residentapp.love"
                target="_blank"
                rel="noreferrer"
              >
                <IconFacebook />
              </a>
              <a
                href="https://www.youtube.com/c/Baselinetelematics"
                target="_blank"
                rel="noreferrer"
              >
                <IconYoutube />
              </a>
              <a
                href="https://twitter.com/residentlove1"
                target="_blank"
                rel="noreferrer"
              >
                <IconTwitter />
              </a>
              <a
                href="https://www.instagram.com/residentapp.love/"
                target="_blank"
                rel="noreferrer"
              >
                <IconInstagram />
              </a>
            </li>
          </ul>
        </FooterColumn>
      </FooterColumnContainer>
      <CopyrightContainer>{translate('copyrights_2020')}</CopyrightContainer>
    </FooterWrapper>
  )
}

export default Footer
